import { render, staticRenderFns } from "./Employer.vue?vue&type=template&id=89129414&scoped=true"
import script from "./Employer.vue?vue&type=script&lang=js"
export * from "./Employer.vue?vue&type=script&lang=js"
import style0 from "./Employer.vue?vue&type=style&index=0&id=89129414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89129414",
  null
  
)

export default component.exports